import type { ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from 'src/gql';

export const ClientPortalHomeTasksQuery = graphql(/* GraphQL */ `
  query ClientPortalHomeTasks($householdId: ID) {
    tasks(household: true, householdId: $householdId) {
      id
      name
      description
      dueAt
      type
      status
    }
  }
`);

export type ClientPortalHomeTasksResult = ResultOf<typeof ClientPortalHomeTasksQuery>;

export type ClientPortalHomeTask = ClientPortalHomeTasksResult['tasks'][number];
